var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.261,
    height: 13.3,
    viewBox: "0 0 11.261 13.3",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.15 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "trash",
    d: "M1721.648,21.455a.386.386,0,0,0-.385.385v6.67a.385.385,0,0,0,.77,0V21.84A.386.386,0,0,0,1721.648,21.455Z",
    transform: "translate(-1716.167 -17.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trash",
    d: "M1725.74,21.455a.386.386,0,0,0-.385.385v6.67a.385.385,0,0,0,.77,0V21.84A.386.386,0,0,0,1725.74,21.455Z",
    transform: "translate(-1718.221 -17.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trash",
    d: "M1721.613,15.313h-2.932v-.637a.893.893,0,0,0-.892-.892h-2.549a.893.893,0,0,0-.892.892v.637h-2.932a.383.383,0,0,0,0,.765h.637v9.559a1.148,1.148,0,0,0,1.147,1.147h6.627a1.148,1.148,0,0,0,1.147-1.147V16.078h.638a.383.383,0,0,0,0-.765Zm-6.373-.765h2.549a.128.128,0,0,1,.128.128v.637h-2.8v-.637A.128.128,0,0,1,1715.24,14.549Zm4.588,11.471H1713.2a.383.383,0,0,1-.383-.383V16.078h7.393v9.559A.383.383,0,0,1,1719.828,26.019Z",
    transform: "translate(-1711.034 -13.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "trash",
    d: "M1717.557,21.455a.386.386,0,0,0-.385.385v6.67a.385.385,0,0,0,.77,0V21.84A.386.386,0,0,0,1717.557,21.455Z",
    transform: "translate(-1714.114 -17.691)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.d31bbc4b.svg";
export { ForwardRef as ReactComponent };